import { useQuery } from 'react-query'
import {
  GET_CATEGORIE_DETAIL_BY_URL_KEY,
  GET_CATEGORIES,
  GET_CATEGORIES_BY_URL_KEY,
} from '~src/api/categories'
import { graphQLClientGET } from '~src/api/graphql'

const STALE_TIME = 5 * 60 * 1000

/** Query options danh mục con theo url_key, dùng chung cho hook dưới và `useQueries` ở Header. */
export const categoryChildrenQuery = (urlKey?: string | null) => ({
  queryKey: ['categoryChildren', urlKey ?? null],
  queryFn: async (): Promise<TChildrenCategories[]> => {
    const data = (await graphQLClientGET.request(GET_CATEGORIES_BY_URL_KEY, {
      eq: urlKey,
    })) as TCategories
    return data.categories?.items?.[0]?.children ?? []
  },
  enabled: !!urlKey,
  staleTime: STALE_TIME,
})

/** Danh mục con của danh mục có url_key cho trước. Key cố định nên nhiều nơi gọi chỉ một request. */
export const useCategoryChildren = (urlKey?: string | null) =>
  useQuery<TChildrenCategories[]>(categoryChildrenQuery(urlKey))

/** Danh mục con của danh mục có uid (đã base64) cho trước, dùng cho các danh mục gốc. */
export const useCategoryChildrenByUid = (uid?: string | null) =>
  useQuery<TChildrenCategories[]>({
    queryKey: ['categoryChildrenByUid', uid ?? null],
    queryFn: async () => {
      const data = (await graphQLClientGET.request(GET_CATEGORIES, { eq: uid })) as TCategories
      return data.categories?.items?.[0]?.children ?? []
    },
    enabled: !!uid,
    staleTime: STALE_TIME,
  })

/**
 * Chi tiết một danh mục theo url_key (có url_path, level, breadcrumbs, ảnh).
 * initialData thường là dữ liệu getStaticProps của cùng slug.
 */
export const useCategoryDetail = (
  urlKey?: string | null,
  initialData?: TChildrenCategories | null
) =>
  useQuery<TChildrenCategories | null>({
    queryKey: ['categoryDetail', urlKey ?? null],
    queryFn: async () => {
      const data = (await graphQLClientGET.request(GET_CATEGORIE_DETAIL_BY_URL_KEY, {
        eq: urlKey,
      })) as TCategories
      return (data.categories?.items?.[0] as unknown as TChildrenCategories | undefined) ?? null
    },
    enabled: !!urlKey,
    staleTime: STALE_TIME,
    initialData: initialData ?? undefined,
  })
